import type { ReactNode } from 'react';
import styles from './MyPlanSectionCard.module.css';

interface MyPlanSectionCardProps {
	title: string;
	subtitle?: string;
	headerAction?: ReactNode;
	children: ReactNode;
}

export const MyPlanSectionCard = ({
	title,
	subtitle,
	headerAction,
	children,
}: MyPlanSectionCardProps) => {
	return (
		<section className={styles.card}>
			<div className={styles.headerRow}>
				<div className={styles.header}>
					<h3 className={styles.title}>{title}</h3>
					{subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
				</div>
				{headerAction ? <div className={styles.headerAction}>{headerAction}</div> : null}
			</div>
			{children}
		</section>
	);
};
